module.exports = __webpack_public_path__ + "static/img/superiority3.1d6b597e.png";